export default "__VITE_ASSET__mmdDyFda__"